import api from '../../services/service_village'
import Swal from 'sweetalert2'
import Pagination from 'vue-pagination-2'
import moment from 'moment'

export default {
  components: {
    Pagination
  },
  data () {
    return {
      header: {
        headers: {
          'access-token': this.$store.state.token
        }
      },
      search: '',
      zone_list: [],
      zone: '',
      village_list: [],
      activePage: 1,
      allItem: 0,
      ItemPerpage: 9,
      village_modal: {
        home_id: null,
        home_number: null,
        home_fullname: null,
        home_area: 0,
        home_entrance_fee: null,
        home_line_token: null,
        home_email: null,
        home_phone: null,
        is_active: 1,
        zone_id: '',
        zone_name: '',
        round_status: 1,
        date_start: this.dateMonth(new Date()),
        date_end: this.dateMonth(new Date())
      }
    }
  },
  created () {
    this.checkUser()
  },
  methods: {
    callback: function (page) {
      this.activePage = page
      this.searchVillage()
    },
    getZoneAll () {
      var obj = {
        search: '',
        active_page: 1,
        per_page: 100000000
      }
      api.getZone(obj, this.header,
        result => {
          if (result.response === true) {
            this.zone_list = result.data.pagination
          } else {
            Swal.fire('ดึงข้อมูลสิทธิ์', result.message, 'warning')
          }
          this.$store.state.isLoading = false
        },
        error => {
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    },
    searchVillage () {
      var obj = {
        search: this.search,
        zone: this.zone,
        active_page: this.activePage,
        per_page: this.ItemPerpage
      }
      this.$store.state.isLoading = true
      api.searchVillages(
        obj,
        this.header,
        result => {
          if (result.response === true) {
            this.village_list = result.data.pagination
            this.allItem = result.data.count
          } else {
            Swal.fire('ดึงข้อมูลผู้ใช้งาน', result.message, 'warning')
          }
          this.$store.state.isLoading = false
        },
        error => {
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    },
    modalVillage (user) {
      if (user) {
        user.date_start = moment(user.date_start).format('YYYY-MM')
        user.date_end = moment(user.date_end).format('YYYY-MM')
        this.village_modal = user
      }
      // eslint-disable-next-line no-undef
      $('#FormVillage').modal('show')
    },
    clearModalVillage () {
      this.village_modal = {
        home_id: null,
        home_number: null,
        home_fullname: null,
        home_area: 0,
        home_entrance_fee: null,
        home_line_token: null,
        home_email: null,
        home_phone: null,
        is_active: 1,
        zone_id: '',
        zone_name: '',
        round_status: 1,
        date_start: this.dateMonth(new Date()),
        date_end: this.dateMonth(new Date())
      }
      // eslint-disable-next-line no-undef
      $('#FormVillage').modal('hide')
      this.searchVillage()
    },
    actionVillage () {
      if (this.village_modal.home_id) {
        this.updateVillage()
      } else {
        this.newVillage()
      }
    },
    newVillage () {
      if (this.village_modal.zone_id !== '') {
        var obj = {
          home_number: this.village_modal.home_number,
          home_fullname: this.village_modal.home_fullname,
          home_area: this.village_modal.home_area,
          home_entrance_fee: this.village_modal.home_entrance_fee,
          home_line_token: this.village_modal.home_line_token,
          home_email: this.village_modal.home_email,
          home_phone: this.village_modal.home_phone,
          zone_id: this.village_modal.zone_id,
          round_status: this.village_modal.round_status,
          date_start: moment(this.village_modal.date_start).format('YYYY-MM-DD'),
          date_end: moment(this.village_modal.date_end).format('YYYY-MM-DD')
        }

        this.$store.state.isLoading = true
        api.addVillage(
          obj,
          this.header,
          result => {
            if (result.response === true) {
              this.searchVillage()
              this.clearModalVillage()
              Swal.fire('เพิ่มข้อมูลทะเบียนบ้าน', result.data, 'success')
            } else {
              this.clearModalVillage()
              Swal.fire('เพิ่มข้อมูลทะเบียนบ้าน', result.data, 'warning')
            }
            this.$store.state.isLoading = false
          },
          error => {
            alert(JSON.stringify(error))
            this.$store.state.isLoading = false
          }
        )
        // eslint-disable-next-line no-undef
        $('#FormVillage').modal('hide')
      } else {
        Swal.fire('แจ้งเตือน', 'กรุณาเลือกโซนที่บ้านตั้งอยู่', 'warning')
      }
    },
    updateVillage () {
      // eslint-disable-next-line no-undef
      $('#FormVillage').modal('hide')
      var obj = {
        home_id: this.village_modal.home_id,
        home_number: this.village_modal.home_number,
        home_fullname: this.village_modal.home_fullname,
        home_area: this.village_modal.home_area,
        home_entrance_fee: this.village_modal.home_entrance_fee,
        home_line_token: this.village_modal.home_line_token,
        home_email: this.village_modal.home_email,
        home_phone: this.village_modal.home_phone,
        zone_id: this.village_modal.zone_id,
        round_status: this.village_modal.round_status,
        date_start: moment(this.village_modal.date_start).format('YYYY-MM-DD'),
        date_end: moment(this.village_modal.date_end).format('YYYY-MM-DD'),
        description: this.village_modal.description,
        is_active: 1
      }
      this.$store.state.isLoading = true
      api.editVillage(
        obj,
        this.header,
        result => {
          if (result.response === true) {
            this.searchVillage()
            this.clearModalVillage()
            Swal.fire('แก้ไขข้อมูลทะเบียนบ้าน', result.data, 'success')
          } else {
            Swal.fire('ดึงข้อมูลทะเบียนบ้าน', result.message, 'warning')
          }
          this.$store.state.isLoading = false
        },
        error => {
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    },
    removeVillage (data) {
      Swal.fire({
        title: 'ลบข้อมูลทะเบียนบ้าน?',
        text: 'ท่านต้องการลบข้อมูลทะเบียนบ้าน บ้านเลขที่ ' + data.home_number + ' ใช่หรือไม่ ?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก',
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.$store.state.isLoading = true
          api.deleteVillage(
            data.home_id,
            this.header,
            result => {
              if (result.response === true) {
                this.searchVillage()
                Swal.fire('ลบข้อมูลทะเบียนบ้าน', 'ลบข้อมูลทะเบียนบ้านเรียบร้อยแล้ว', 'success')
              } else {
                Swal.fire('ดึงข้อมูลทะเบียนบ้าน', result.message, 'warning')
              }
              this.$store.state.isLoading = false
            },
            error => {
              alert(JSON.stringify(error))
              this.$store.state.isLoading = false
            }
          )
        }
      })
    }
  },
  mounted () {
    moment.locale('th')
    this.searchVillage()
    this.getZoneAll()
    // eslint-disable-next-line no-undef
    $('body').on('hidden.bs.modal', '.modal', function () {
    // eslint-disable-next-line no-undef
      $(this).removeData('bs.modal')
    })
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/villages.js